// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__4f7oB","rootSuccess":"CompleteLink_rootSuccess__2jRJk","rootFailure":"CompleteLink_rootFailure__G_dLi","isDisabled":"CompleteLink_isDisabled__1fYqn"};